export enum VendorPayoutTransactionStatus {
    PENDING =  "PENDING", 
    APPROVED =  "APPROVED",  
    REJECTED = "REJECTED",
    PROCESSED = "PROCESSED",
    PROCESSING_FAILED = "PROCESSING_FAILED",
    PROCESSING_IN_PROGRESS = "PROCESSING_IN_PROGRESS"
}